import * as NotesActions from "./notesActions";

export default NotesActions;
